let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hvVQq")).then(() => parcelRequire('l92F7'));